import React from 'react';
import { Link } from 'react-router-dom';

interface NavigationItem {
  name: string;
  href: string;
}

interface Navigation {
  solutions: NavigationItem[];
  products: NavigationItem[];
  company: NavigationItem[];
}

const navigation: Navigation = {
  solutions: [
    { name: 'AI Diagnostics', href: '/solutions#diagnostics' },
    { name: 'Clinical Workflow', href: '/solutions/clinical-workflow' },
    { name: 'Patient Engagement', href: '/solutions/patient-engagement' },
    { name: 'Analytics Platform', href: '/solutions/analytics' },
  ],
   products: [
    { name: 'Flagship Product', href: '/products/ai-platform' },
    { name: 'Clinical Tools', href: '/products/clinical-tools' },
    { name: 'Integration Hub', href: '/products/integration-hub' },
    { name: 'API Access', href: '#' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    //{ name: 'Careers', href: '/blog' },
    //{ name: 'Founder Research', href: '/careers' },
    { name: 'Contact', href: '/contact' },
  ],

};

function Footer() {
  return (
    <footer className="bg-[#040d16] border-t border-gray-800" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8">
            <Link to="/" className="flex items-center space-x-3">
              <img src="logo512.png" alt="eighty-nine AI" className="h-10 w-10" />
              <span className="text-xl font-bold text-white">
                eighty-nine AI
              </span>
            </Link>
            <p className="text-sm leading-6 text-gray-300">
              Transforming healthcare in Africa with AI-powered solutions.
            </p>
          
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">Solutions</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.solutions.map((item) => (
                    <li key={item.name}>
                      <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-white">Products</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.products.map((item) => (
                    <li key={item.name}>
                      <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">Company</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-xs leading-5 text-gray-400">
            &copy; {new Date().getFullYear()} eighty-nine AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
